import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Queries {

  me(): DocumentNode {
    return gql`
      query getAuthenticatedUser {
        me {
          id
          name
          email
          avatarUrl
          type
          emailHash
          fieldNewsEmailHash
          role
          loginIntegrationEnabled
          account {
            id
            name
            featureFlags {
              name
              active
            }
          }
          preferences {
            featureOpenedMaintenanceSendEmailNotification
          }
          authenticationInfo {
            enabled
            status
          }
          groups {
            id
            name
            permissions {
              name
              category
            }
          }
        }
        accountPreferences {
          openMaintenance {
            featureDisableOpenMaintenanceOnPanel
            featureProblemRequired
            maintenanceNumberGenerator
          }
          forms {
            questionsLimit
            questionOptionsLimit
            featureFormsWithScoredOptions
          }
          quotations {
            featureApproveQuotationByPanel
            featureApproveQuotationByLink
          }
          other {
            featureLocationsPermissionsEnabled
          }
        }
      }
    `;
  }

  getUser(): DocumentNode {
    return gql`
      query getOneUser($id: ID!) {
        user(id: $id) {
          id
          name
          email
          createdAt
          archived
          avatarUrl
          type
          groups {
            id
            name
            description
            archived
          }
          preferences {
            featureOpenedMaintenanceSendEmailNotification
          }
        }
      }
    `;
  }

  getUsers(): DocumentNode {
    return gql`
      query queryPagedUsers (
        $where: UserWhereInput,
        $orderBy: UserOrderByInput,
        $limit: Int,
        $offset: Int
      ) {
        users(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          totalCount
          items {
            id
            name
            email
            createdAt
            archived
            avatarUrl
            type
          }
        }
      }
    `;
  }
}
